import {Component, inject, output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {CustomInputComponent} from '../../input/custom-input/custom-input.component';
import {ImagesService} from '../../../services/general/images.service';
import {AuthService} from '../../../services/auth/auth.service';
import {ToastService} from '../../../services/general/toast.service';
import {PrimaryButtonComponent} from '../../buttons/primary-button/primary-button.component';

@Component({
  selector: 'app-change-password',
  imports: [
    CustomInputComponent,
    CommonModule,
    ReactiveFormsModule,
    PrimaryButtonComponent,
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  _images = inject(ImagesService);
  _fb = inject(FormBuilder);
  authService = inject(AuthService);
  _toast = inject(ToastService);

  isLoading: boolean = false;

  passwordForm: FormGroup = this._fb.group({
    oldPassword: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    passwordConfirmation: ['', [Validators.required]],
  }, {
    validators: this.passwordMatchValidator
  });

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const passwordConfirmation = group.get('passwordConfirmation')?.value;
    return password === passwordConfirmation ? null : { passwordMismatch: true };
  }

  closePassword = output<void>();

  onClose() {
    this.passwordForm.reset();
    this.passwordForm.markAsPristine();
    this.passwordForm.markAsUntouched();
    this.closePassword.emit();
  }

  onSubmit() {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }

    const formValue = this.passwordForm.value;
    const changePasswordData = {
      oldPassword: formValue.oldPassword ?? '',
      password: formValue.password ?? '',
      passwordConfirmation: formValue.passwordConfirmation ?? '',
    };

    this.isLoading = true;
    this.authService.changePassword(changePasswordData).subscribe({
      next: () => {
        this._toast.success('Password changed successfully');
        this.onClose();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error changing password:', error);
        const errorMessage = error?.error?.message || error?.message || 'Error changing password';
        
        if (error?.status === 422) {
          this._toast.error('Invalid current password');
        } else if (error?.status === 400) {
          this._toast.error('Bad request. Please check your input.');
        } else {
          this._toast.error(errorMessage);
        }
        this.isLoading = false;
      }
    });
  }
}

